const types = {
    SET_LIST: '[TOURNAMENT] SET LIST',
    SET_VIEW: '[TOURNAMENT] SET VIEW',
    SET_LIST_STAT: '[TOURNAMENT] SET LIST STAT',
    SET_SEARCH_GAME: '[TOURNAMENT] SET SEARCH GAME'
}

export {
    types
}